import { __extends } from "tslib";
import { deserializeAws_restJson1_1UpdateApplicationSettingsCommand, serializeAws_restJson1_1UpdateApplicationSettingsCommand } from "../protocols/Aws_restJson1_1";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var UpdateApplicationSettingsCommand = /** @class */ (function (_super) {
    __extends(UpdateApplicationSettingsCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function UpdateApplicationSettingsCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    UpdateApplicationSettingsCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    UpdateApplicationSettingsCommand.prototype.serialize = function (input, context) {
        return serializeAws_restJson1_1UpdateApplicationSettingsCommand(input, context);
    };
    UpdateApplicationSettingsCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restJson1_1UpdateApplicationSettingsCommand(output, context);
    };
    return UpdateApplicationSettingsCommand;
}($Command));
export { UpdateApplicationSettingsCommand };
//# sourceMappingURL=UpdateApplicationSettingsCommand.js.map